var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":'https://www.helloasso.com/associations/camptocamp-association/adhesions/adhesions-' +
      _vm.currentYear +
      '-camptocamp-association',"title":_vm.$gettext('Join us')}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }